import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FeatureVisibleDirective,
  FeatureNavStateDirective,
  FeatureWritableDirective,
  FeatureActionStateDirective,
  NonProjectFeatureVisibleDirective,
  NonProjectFeatureNavStateDirective
} from './feature-access.directives';

@NgModule({
  imports: [CommonModule],
  declarations: [
    FeatureVisibleDirective,
    FeatureNavStateDirective,
    FeatureWritableDirective,
    FeatureActionStateDirective,
    NonProjectFeatureVisibleDirective,
    NonProjectFeatureNavStateDirective
  ],
  exports: [
    FeatureVisibleDirective,
    FeatureNavStateDirective,
    FeatureWritableDirective,
    FeatureActionStateDirective,
    NonProjectFeatureVisibleDirective,
    NonProjectFeatureNavStateDirective
  ]
})
export class FeatureAccessModule {}
